import { toast } from 'react-toastify'
import { deleteUrls } from 'services/api.enums'
import { deleteDataAPI } from 'services/CRUDServices'

export function useDeleteSubZoneArea(setOpenDeleteModal, getZoneInfo) {
  const handleDeleteZoneArea = async (Data) => {
    try {
      await deleteDataAPI(deleteUrls.deleteSubZonePolygon, '', true, {
        province: { id: Data.id, text: '' },
        hubId: Data.selectHub.id,
      })
      setOpenDeleteModal(false)
      toast.success('منطقه عملیاتی با موفقیت حذف شد ')
      getZoneInfo()
    } catch (error) {}
  }

  return { handleDeleteZoneArea }
}

export default useDeleteSubZoneArea
